<script setup lang="ts">
import { VAN_AND_ROAD, STAFF_MEETING, COMMUNITY, SQUARE_KEYS } from '~/constants/pictures'

const { t } = useI18n()

useSeoText({ title: t('commons.links.travelers_hit_the_road'), description: t('pages.hit_the_road.meta.description') })

const advices = [
  {
    text: t('pages.hit_the_road.resume.profil_verified'),
    icon: resolveComponent('YscIconsLegal'),
  },
  {
    text: t('pages.hit_the_road.resume.insurance'),
    icon: resolveComponent('YscIconsInsuranceCover'),
  },
  {
    text: t('pages.hit_the_road.resume.team'),
    icon: resolveComponent('YscIconsStarRating2'),
  },
]

const articles = [
  {
    title: t('pages.hit_the_road.advantages.security.title'),
    content: t('pages.hit_the_road.advantages.security.content'),
    picture: VAN_AND_ROAD,
  },
  {
    title: t('pages.hit_the_road.advantages.care.title'),
    content: t('pages.hit_the_road.advantages.care.content'),
    picture: STAFF_MEETING,
  },
  {
    title: t('pages.hit_the_road.advantages.community.title'),
    content: t('pages.hit_the_road.advantages.community.content'),
    picture: COMMUNITY,
  },
  {
    title: t('pages.hit_the_road.advantages.peertopeer.title'),
    content: t('pages.hit_the_road.advantages.peertopeer.content'),
    picture: SQUARE_KEYS,
  },
]
const { getTranslatedLink } = useGetTranslatedLink()
</script>

<template>
  <div>
    <AppPageSection>
      <AppAcquisitionSeduceArguments :advices="advices" />
      <AppPageArticles :articles="articles" />
      <div class="text-center">
        <NuxtLink
          :to="{ name: 's' }"
          class="btn btn-primary"
        >
          {{ getTranslatedLink('s') }}
        </NuxtLink>
      </div>
    </AppPageSection>

    <AppHowItWorksSection user-type="guest">
      <template #subtitle>
        {{ $t('components.app_how_it_works.subtitle_guest') }}
      </template>
    </AppHowItWorksSection>

    <AppSearchSection />

    <AppPageSection>
      <template #title>
        {{ $t('pages.hit_the_road.testimonials.title') }}
      </template>

      <AppReviewTestimonial />

      <div class="mt-12 text-center">
        <NuxtLink
          :to="{ name: 'community-all-reviews' }"
          class="btn btn-primary"
        >
          {{ $t('pages.hit_the_road.testimonials.link') }}
        </NuxtLink>
      </div>
    </AppPageSection>
  </div>
</template>
